//@flow

export const LOAD_MODELS_DETAILS: string = 'loadModelsDetails';
export const LOAD_MODELS_DETAILS_SUCCESS: string = 'loadModelsDetailsSuccess';
export const LOAD_MODELS_DETAILS_FAIL: string = 'loadModelsDetailsFail';
export const SET_SELECTED_MODEL_INDEX: string = 'setSelectedModelIndex';
export const SELECTED_MODEL_INDEX: string = 'selectedModelIndex';
export const SELECT_MODEL: string = 'select_model';
export const MODELS_DETAILS: string = 'models_details';
export const MODELS: string = 'models';
export const FLIGHT_ID: string = 'projectId';
export const ERROR: string = 'modelRelatedError';
export const CLEAR_ERROR: string = 'clearModelRelatedError';
export const DELETE_MODEL: string = 'deleteModel';
export const DELETE_MODEL_SUCCESS: string = 'deleteModelSuccess';
export const DELETE_MODEL_FAIL: string = 'deleteModelFails';

export type ModelDetail = {
  dateTime: string,
  flight: any,
  projectId: number,
  id: number,
  url: string,
  description: string,
};

export type ModelMetaData = {
  createdByUserId: number,
  createdDateTime: string,
  url: string,
  description: string,
  projectId: number,
  id: number,
  modifiedByUserId: number,
};

export type ModelProps = {
  title: String,
  loadModelsDetails: (axiosInstance: any, projectId: number) => {},
  models: Array<ModelMetaData>,
  projectId: number,
  axiosInstance: any,
  chosenFlight: any,
  selectedModelIndex: number,
  setSelectedModelIndex: (index: number) => void,
  deleteModel: (index: number) => void,
  clearError: () => void,
};


// WEBPACK FOOTER //
// ./src/types/model.jsx